import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close",
  "use": "close-usage",
  "viewBox": "0 0 60 60",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 60 60\" id=\"close\"><g><path d=\"M29.41 27.054L40.254 16.21a2.5 2.5 0 1 1 3.536 3.536L32.946 30.589l10.607 10.607a2.5 2.5 0 0 1-3.536 3.535L29.411 34.125 19.04 44.495a2.5 2.5 0 0 1-3.536-3.535l10.371-10.37L15.27 19.982a2.5 2.5 0 0 1 3.535-3.536l10.607 10.607z\" fill-rule=\"evenodd\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol